import { Instance, types } from 'mobx-state-tree';
import { BatchClass } from '@models/BatchClass';

export const Batch = types.model('BatchModel', {
  id: types.string,
  name: types.maybeNull(types.string),
  year: types.maybeNull(types.number),
  batch_classes: types.optional(types.array(BatchClass), []),
  intake: types.model({
    id: types.string,
    name: types.string,
  }),
});

export type BatchModelType = Instance<typeof Batch>;
